import React from 'react';

function SolutionsPage() {
  return (
    <div className="container mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold text-gray-900 mb-8">Solutions</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {/* Enterprise Solutions */}
        <div className="bg-white rounded-lg shadow-lg p-6">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Enterprise</h2>
          <p className="text-gray-600 mb-4">
            Comprehensive solutions tailored for large organizations with complex customer management needs.
          </p>
          <ul className="space-y-2 text-gray-700">
            <li>• Advanced analytics and reporting</li>
            <li>• Multi-team collaboration tools</li>
            <li>• Custom integration options</li>
            <li>• Dedicated support team</li>
          </ul>
        </div>

        {/* Small Business Solutions */}
        <div className="bg-white rounded-lg shadow-lg p-6">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Small Business</h2>
          <p className="text-gray-600 mb-4">
            Flexible and scalable solutions designed to help small businesses grow and succeed.
          </p>
          <ul className="space-y-2 text-gray-700">
            <li>• Easy-to-use interface</li>
            <li>• Essential features bundle</li>
            <li>• Affordable pricing plans</li>
            <li>• Quick setup process</li>
          </ul>
        </div>

        {/* Industry-Specific Solutions */}
        <div className="bg-white rounded-lg shadow-lg p-6">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Industry-Specific</h2>
          <p className="text-gray-600 mb-4">
            Specialized solutions customized for different industry verticals and use cases.
          </p>
          <ul className="space-y-2 text-gray-700">
            <li>• Retail optimization</li>
            <li>• Healthcare compliance</li>
            <li>• Financial services tools</li>
            <li>• Technology sector features</li>
          </ul>
        </div>
      </div>

      {/* Contact Section */}
      <div className="mt-16 bg-gray-50 rounded-xl p-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Need a custom solution?
          </h2>
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
            Our team of experts is ready to help you find the perfect solution for your specific needs.
            Let's discuss how we can help your business succeed.
          </p>
          <button className="bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors">
            Contact Sales
          </button>
        </div>
      </div>
    </div>
  );
}

export default SolutionsPage;